export var X_FIELD = 'x';
export var Y_FIELD = 'y';
export var COLOR_FIELD = 'name';